export default __webpack_public_path__ + "static/media/cert1.9b37f7b6.jpg";